import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { Observable, combineLatest, map, filter } from 'rxjs'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { AppState } from 'src/app/store/state/app.state'
import { getEnabledModules, getSettingsLoaded } from 'src/app/store/selector/company-settings.selector'
import { getUserTypeFromState } from 'src/app/store/selector/initialize.selector'

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {
  readonly DASHBOARD = `/${GlobalConstants.ROUTING.DASHBOARD}`
  readonly ACTIVITY_DASHBOARD = `/${GlobalConstants.ROUTING.ACTIVITY}/${GlobalConstants.ROUTING.DASHBOARD}`
  readonly QUERY_DASHBOARD = `/${GlobalConstants.ROUTING.QUERY}/${GlobalConstants.ROUTING.DASHBOARD}`
  readonly GOVERNMENT_BUSINESS_DASHBOARD = `/${GlobalConstants.ROUTING.GOVERNMENT_BUSINESS}/${GlobalConstants.ROUTING.DASHBOARD}`
  readonly PROFILE = `/${GlobalConstants.ROUTING.PROFILE}`
  readonly SETTINGS = `/${GlobalConstants.ROUTING.SETTINGS}`
  readonly KNOWLEDGE_HUB = `/${GlobalConstants.ROUTING.KNOWLEDGE_HUB}/${GlobalConstants.ROUTING.SEARCH}`
  readonly CALENDER_INFO = `/${GlobalConstants.ROUTING.CALENDAR_INFO}/${GlobalConstants.ROUTING.SUMMARY}`
  readonly EMPLOYEE_INFO = `/${GlobalConstants.ROUTING.EMPLOYEE_INFO}/${GlobalConstants.ROUTING.SUMMARY}`
  readonly DATA_REPOSITORY = `/${GlobalConstants.ROUTING.DATA_REPOSITORY}/${GlobalConstants.ROUTING.QUICK_SELECT}`
  readonly ANNOUNCEMENT = `/${GlobalConstants.ROUTING.ANNOUNCEMENT}/${GlobalConstants.ROUTING.SUMMARY}`
  readonly REPORTS = `/${GlobalConstants.ROUTING.REPORTS}`
  readonly OFFLINE_TRACKER_SUMMARY = `/${GlobalConstants.ROUTING.OFFLINE_TRACKER}/${GlobalConstants.ROUTING.SUMMARY}`

  isEmployeeAdmin$: Observable<boolean>
  enabledModules$: Observable<string[]>
  settingsLoaded$: Observable<boolean>
  /* true when either: RMS User, or settings have loaded */
  moduleNavReady$: Observable<boolean>

  constructor(private readonly store: Store<AppState>) {}

  ngOnInit() {
    this.isEmployeeAdmin$ = this.store.select(getUserTypeFromState).pipe(
      filter(userType => !!userType),
      map(userType => userType === GlobalConstants.USER_TYPE.EMPLOYEE_ADMIN)
    )
    this.enabledModules$ = this.store.select(getEnabledModules)
    this.settingsLoaded$ = this.store.select(getSettingsLoaded)
    this.moduleNavReady$ = combineLatest([this.isEmployeeAdmin$, this.settingsLoaded$]).pipe(
      map(([isEEAdmin, loaded]) => !isEEAdmin || loaded)
    )
  }

  isModuleEnabled(moduleKey: string): Observable<boolean> {
    return combineLatest([this.isEmployeeAdmin$, this.enabledModules$]).pipe(
      map(([isEEAdmin, modules]) => !isEEAdmin || modules.includes(moduleKey))
    )
  }
}
